/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { BillingDetails } from './BillingDetails';
// @ts-ignore
import {
// @ts-ignore
    BillingDetailsFromJSON,
// @ts-ignore
    BillingDetailsFromJSONTyped,
// @ts-ignore
    BillingDetailsToJSON,
} from './BillingDetails';
// @ts-ignore
import type { InvoiceLine } from './InvoiceLine';
// @ts-ignore
import {
// @ts-ignore
    InvoiceLineFromJSON,
// @ts-ignore
    InvoiceLineFromJSONTyped,
// @ts-ignore
    InvoiceLineToJSON,
} from './InvoiceLine';
// @ts-ignore
import type { InvoiceStatus } from './InvoiceStatus';
// @ts-ignore
import {
// @ts-ignore
    InvoiceStatusFromJSON,
// @ts-ignore
    InvoiceStatusFromJSONTyped,
// @ts-ignore
    InvoiceStatusToJSON,
} from './InvoiceStatus';
// @ts-ignore
import type { InvoiceTransactionStatus } from './InvoiceTransactionStatus';
// @ts-ignore
import {
// @ts-ignore
    InvoiceTransactionStatusFromJSON,
// @ts-ignore
    InvoiceTransactionStatusFromJSONTyped,
// @ts-ignore
    InvoiceTransactionStatusToJSON,
} from './InvoiceTransactionStatus';
// @ts-ignore
import type { TimeWindow } from './TimeWindow';
// @ts-ignore
import {
// @ts-ignore
    TimeWindowFromJSON,
// @ts-ignore
    TimeWindowFromJSONTyped,
// @ts-ignore
    TimeWindowToJSON,
} from './TimeWindow';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    subscriptionId: string;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof Invoice
     */
    status: InvoiceStatus;
    /**
     * 
     * @type {InvoiceTransactionStatus}
     * @memberof Invoice
     */
    paymentStatus?: InvoiceTransactionStatus | null;
    /**
     * 
     * @type {TimeWindow}
     * @memberof Invoice
     */
    period: TimeWindow;
    /**
     * 
     * @type {Amount}
     * @memberof Invoice
     */
    subtotalAmount: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof Invoice
     */
    taxAmount: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof Invoice
     */
    totalAmount: Amount;
    /**
     * 
     * @type {Array<InvoiceLine>}
     * @memberof Invoice
     */
    lines: Array<InvoiceLine>;
    /**
     * 
     * @type {BillingDetails}
     * @memberof Invoice
     */
    billingDetails: BillingDetails;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the Invoice interface.
 */
// @ts-ignore
export function instanceOfInvoice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "invoiceNumber" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "subscriptionId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "period" in value;
    isInstance = isInstance && "subtotalAmount" in value;
    isInstance = isInstance && "taxAmount" in value;
    isInstance = isInstance && "totalAmount" in value;
    isInstance = isInstance && "lines" in value;
    isInstance = isInstance && "billingDetails" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

// @ts-ignore
export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

// @ts-ignore
export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'invoiceNumber': json['invoice_number'],
        'description': json['description'],
        'subscriptionId': json['subscription_id'],
        'status': InvoiceStatusFromJSON(json['status']),
        'paymentStatus': !exists(json, 'payment_status') ? undefined : InvoiceTransactionStatusFromJSON(json['payment_status']),
        'period': TimeWindowFromJSON(json['period']),
        'subtotalAmount': AmountFromJSON(json['subtotal_amount']),
        'taxAmount': AmountFromJSON(json['tax_amount']),
        'totalAmount': AmountFromJSON(json['total_amount']),
        'lines': ((json['lines'] as Array<any>).map(InvoiceLineFromJSON)),
        'billingDetails': BillingDetailsFromJSON(json['billing_details']),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

// @ts-ignore
export function InvoiceToJSON(value?: Invoice | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'invoice_number': value.invoiceNumber,
        'description': value.description,
        'subscription_id': value.subscriptionId,
        'status': InvoiceStatusToJSON(value.status),
        'payment_status': InvoiceTransactionStatusToJSON(value.paymentStatus),
        'period': TimeWindowToJSON(value.period),
        'subtotal_amount': AmountToJSON(value.subtotalAmount),
        'tax_amount': AmountToJSON(value.taxAmount),
        'total_amount': AmountToJSON(value.totalAmount),
        'lines': ((value.lines as Array<any>).map(InvoiceLineToJSON)),
        'billing_details': BillingDetailsToJSON(value.billingDetails),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

